import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from 'src/app/interfaces';
import { IPostDocumento } from 'src/app/interfaces/documento';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService {
  private readonly baseURL = '/Documento';
  constructor(private httpClient: HttpClient) {}

  postDocumento() {
    return this.httpClient.post<IApiResponse<IPostDocumento[]>>(this.baseURL, {})
  }

}